<template>
  <div class="frame-widget" v-show="boxData.judgeBox" :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, position: 'absolute'}" @mousedown.stop.prevent>
    <ul class="btns">
      <li class="btn" v-for="(btn) in list" :key="btn.action" @click="onBtnClicked(btn)">
        <i :class="[btn.icon]"></i>
        <span>{{btn.text}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import popup from '../mixins/popup'

export default {
  mixins: [popup],
  data () {
    return {
      popupType: 'frameWidget',
      list: [
        {text: '裁剪图片', action: 'cut', icon: 'icon-sprite-crop'},
        {text: '替换图片', action: 'swap', icon: 'icon-sprite-swap'}
      ]
    }
  },
  watch: {
    'boxData.judgeBox' (val) {
      if (val) {
        this.sprite = this.SelectSprites_Msg[0];
      }
    }
  },
  created () {
    this.$bus.on('showFrameWidget', () => {
      const vm = this;
      let sprite = vm.SelectSprites_Msg[0];
      this.$bus.emit('FeaturesPop_vue', {
        type: 1,
        name: 'frameWidget',
        initialX: vm.TOOL.PfixLeft + sprite.positionLeft + sprite.width * 0.9,
        initialY: vm.TOOL.PfixTop + sprite.positionTop + sprite.height / 2
      })
    })
  },
  methods: {
    showImagePopup () {
      this.$bus.emit('showSelectFrameImage');
    },
    goCut () {
      if(!this.sprite.picData.picSize) {
        return;
      }
      this.$bus.emit('cutFrame_vue');
      this.sprite.action = 'cut';
    },
    onBtnClicked (btn) {
      if (btn.action === 'swap') {
        this.showImagePopup();
        this.$analysis({category:'editable_frame', action:'click_editable_frame_change_photos', label:'相框_替换图片'})
      }
      if (btn.action === 'cut') {
        this.goCut();
        this.$analysis({category:'editable_frame', action:'click_editable_frame_crop_photos', label:'相框_剪裁图片'})
      }

      this.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.btns {
  position: relative;
  background-color: #fff;
  width: 116px;
  padding: 3px;
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border-radius: 4px;
  color: #474261;
  margin-bottom: 3px;
  // background-color: #f0f0f8;

  &:last-child {
    margin-bottom: 0;
  }

  & > span {
    padding-left: 0.5em;
    width: 70px;
    white-space: nowrap;
  }

  &:hover {
    background-color: #D4D4E7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/frameWidget.vue